export function capitalizeString(str: string) {
  const [firstLetter] = str;

  return str.replace(firstLetter, firstLetter.toUpperCase());
}
